import React from 'react';
import PropTypes from 'prop-types';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { toUpper } from "../../../utils/to-upper";
import { size } from "../../../utils/size";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { EmailCapture } from "../../general-widgets/EmailCapture";
import { Submenu } from "../../elements/Submenu";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { Divider } from "../../elements/Divider";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { getHrefTelString } from "../../../utils/get-href-tel-string";
import { EMAIL, FAX, FORM_PROTECTION } from "../../../utils/default-strings/constants";
import { getHrefFaxString } from "./utils/getHrefFaxString";
import { getHrefMailToString } from "./utils/getHrefMailToString";
import { getAreNavigationItemsGrouped } from "./utils/getAreNavigationItemsGrouped";
import { getGroupedNavigationItems } from "./utils/getGroupedNavigationItems";
import { getMenuItemMarkup } from "./utils/getMenuItemMarkup";
export var Component = function Component(_ref) {
  var copyrightText = _ref.copyrightText,
      currencyNoResultsText = _ref.currencyNoResultsText,
      currencyOptions = _ref.currencyOptions,
      currencyValue = _ref.currencyValue,
      emailAddress = _ref.emailAddress,
      emailAddressLabel = _ref.emailAddressLabel,
      emailBotProtectionMessage = _ref.emailBotProtectionMessage,
      emailCaptureButtonText = _ref.emailCaptureButtonText,
      emailCaptureErrorMessage = _ref.emailCaptureErrorMessage,
      emailCaptureHeadingText = _ref.emailCaptureHeadingText,
      emailCaptureInputError = _ref.emailCaptureInputError,
      emailCaptureInputLabel = _ref.emailCaptureInputLabel,
      emailCaptureInputValue = _ref.emailCaptureInputValue,
      emailCaptureOnClickButton = _ref.emailCaptureOnClickButton,
      emailCapturePrivacyConsentInputError = _ref.emailCapturePrivacyConsentInputError,
      emailCapturePrivacyConsentLabelLinkText = _ref.emailCapturePrivacyConsentLabelLinkText,
      emailCapturePrivacyConsentLabelLinkUrl = _ref.emailCapturePrivacyConsentLabelLinkUrl,
      emailCapturePrivacyConsentLabelText = _ref.emailCapturePrivacyConsentLabelText,
      emailCaptureSuccessMessage = _ref.emailCaptureSuccessMessage,
      faxNumber = _ref.faxNumber,
      faxNumberLabel = _ref.faxNumberLabel,
      hasEmailCapture = _ref.hasEmailCapture,
      isEmailBotProtected = _ref.isEmailBotProtected,
      isEmailCapturePrivacyConsentInputChecked = _ref.isEmailCapturePrivacyConsentInputChecked,
      isEmailCapturePrivacyConsentRequired = _ref.isEmailCapturePrivacyConsentRequired,
      languageOptions = _ref.languageOptions,
      languageValue = _ref.languageValue,
      navigationItems = _ref.navigationItems,
      onChangeCurrency = _ref.onChangeCurrency,
      onChangeEmailCaptureInput = _ref.onChangeEmailCaptureInput,
      onChangeLanguage = _ref.onChangeLanguage,
      onClickEmailCapturePrivacyConsentInput = _ref.onClickEmailCapturePrivacyConsentInput,
      phoneNumber = _ref.phoneNumber,
      propertyAddress = _ref.propertyAddress,
      socialMediaLinks = _ref.socialMediaLinks;
  return React.createElement("footer", null, hasEmailCapture && React.createElement(EmailCapture, {
    buttonText: emailCaptureButtonText,
    emailInputError: emailCaptureInputError,
    emailInputLabel: emailCaptureInputLabel,
    emailInputValue: emailCaptureInputValue,
    errorMessage: emailCaptureErrorMessage,
    headingText: emailCaptureHeadingText,
    isBotProtected: isEmailBotProtected,
    isPrivacyConsentInputChecked: isEmailCapturePrivacyConsentInputChecked,
    isPrivacyConsentRequired: isEmailCapturePrivacyConsentRequired,
    notProtectionMessage: emailBotProtectionMessage,
    onChangeEmailInput: onChangeEmailCaptureInput,
    onClickButton: emailCaptureOnClickButton,
    onClickPrivacyConsentInput: onClickEmailCapturePrivacyConsentInput,
    privacyConsentInputError: emailCapturePrivacyConsentInputError,
    privacyConsentLabelLinkText: emailCapturePrivacyConsentLabelLinkText,
    privacyConsentLabelLinkUrl: emailCapturePrivacyConsentLabelLinkUrl,
    privacyConsentLabelText: emailCapturePrivacyConsentLabelText,
    successMessage: emailCaptureSuccessMessage
  }), size(navigationItems) > 0 && React.createElement("div", {
    className: "top-navigation"
  }, React.createElement(HorizontalGutters, {
    as: Menu,
    borderless: true,
    inverted: true,
    stackable: true
  }, getAreNavigationItemsGrouped(navigationItems) ? getGroupedNavigationItems(navigationItems).map(function (_ref2, index) {
    var text = _ref2.text,
        href = _ref2.href,
        target = _ref2.target,
        subItems = _ref2.subItems;
    return React.createElement(Menu.Item, {
      className: "grouped",
      key: buildKeyFromStrings(text || subItems[0].text, index)
    }, React.createElement(Menu.Menu, null, text && React.createElement(Menu.Header, null, !!href ? React.createElement("a", {
      href: href,
      target: target
    }, toUpper(text)) : toUpper(text)), subItems.map(getMenuItemMarkup)));
  }) : navigationItems.map(getMenuItemMarkup))), React.createElement("div", {
    className: "bottom-navigation"
  }, React.createElement(HorizontalGutters, {
    as: Menu,
    borderless: true,
    inverted: true,
    stackable: true
  }, React.createElement(Menu.Menu, null, size(languageOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    items: languageOptions,
    name: "language",
    onChange: onChangeLanguage,
    value: languageValue,
    willOpenAbove: true
  })), size(currencyOptions) > 1 && React.createElement(Menu.Item, null, React.createElement(Submenu, {
    isSearchable: true,
    items: currencyOptions,
    name: "currency",
    noResultsText: currencyNoResultsText,
    onChange: onChangeCurrency,
    value: currencyValue,
    willOpenAbove: true
  })), !!phoneNumber && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, React.createElement("a", {
    href: getHrefTelString(phoneNumber)
  }, React.createElement(Icon, {
    labelText: phoneNumber,
    name: ICON_NAMES.PHONE
  })))), size(socialMediaLinks) > 0 && React.createElement(Menu.Menu, {
    position: "right"
  }, socialMediaLinks.map(function (_ref3, index) {
    var href = _ref3.href,
        iconName = _ref3.iconName,
        iconPath = _ref3.iconPath,
        target = _ref3.target;
    return React.createElement(Menu.Item, {
      href: href,
      key: buildKeyFromStrings(href, index),
      link: true,
      target: target
    }, React.createElement(Icon, {
      name: iconName,
      path: iconPath
    }));
  })), React.createElement(Divider, {
    hasLine: true
  }), React.createElement(Menu.Menu, null, propertyAddress && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, propertyAddress), faxNumber && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, React.createElement("label", null, faxNumberLabel), React.createElement("a", {
    href: getHrefFaxString(faxNumber)
  }, faxNumber)), emailAddress && React.createElement(Menu.Item, {
    className: "is-selectable"
  }, React.createElement("label", null, emailAddressLabel), React.createElement("a", {
    href: getHrefMailToString(emailAddress)
  }, emailAddress)), copyrightText && React.createElement(Menu.Item, {
    className: "is-selectable",
    position: "right"
  }, copyrightText)))));
};
Component.displayName = 'Footer';
Component.defaultProps = {
  copyrightText: null,
  currencyNoResultsText: undefined,
  currencyOptions: [],
  currencyValue: null,
  emailAddress: undefined,
  emailAddressLabel: EMAIL,
  emailBotProtectionMessage: FORM_PROTECTION,
  emailCaptureButtonText: undefined,
  emailCaptureErrorMessage: undefined,
  emailCaptureHeadingText: undefined,
  emailCaptureInputError: undefined,
  emailCaptureInputLabel: undefined,
  emailCaptureInputValue: undefined,
  emailCaptureOnClickButton: undefined,
  emailCapturePrivacyConsentInputError: undefined,
  emailCapturePrivacyConsentLabelLinkText: undefined,
  emailCapturePrivacyConsentLabelLinkUrl: undefined,
  emailCapturePrivacyConsentLabelText: undefined,
  emailCaptureSuccessMessage: undefined,
  faxNumber: undefined,
  faxNumberLabel: FAX,
  hasEmailCapture: false,
  isEmailBotProtected: false,
  isEmailCapturePrivacyConsentInputChecked: undefined,
  isEmailCapturePrivacyConsentRequired: undefined,
  languageOptions: [],
  languageValue: null,
  navigationItems: null,
  onChangeEmailCaptureInput: undefined,
  onClickEmailCapturePrivacyConsentInput: undefined,
  phoneNumber: null,
  propertyAddress: undefined,
  socialMediaLinks: []
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  copyrightText: PropTypes.string,
  currencyNoResultsText: PropTypes.string,
  currencyOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  currencyValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  emailAddress: PropTypes.string,
  emailAddressLabel: PropTypes.string,
  emailBotProtectionMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  emailCaptureButtonText: PropTypes.string,
  emailCaptureErrorMessage: PropTypes.string,
  emailCaptureHeadingText: PropTypes.string,
  emailCaptureInputError: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  emailCaptureInputLabel: PropTypes.string,
  emailCaptureInputValue: PropTypes.string,
  emailCaptureOnClickButton: PropTypes.func,
  emailCapturePrivacyConsentInputError: PropTypes.string,
  emailCapturePrivacyConsentLabelLinkText: PropTypes.string,
  emailCapturePrivacyConsentLabelLinkUrl: PropTypes.string,
  emailCapturePrivacyConsentLabelText: PropTypes.string,
  emailCaptureSuccessMessage: PropTypes.string,
  faxNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  faxNumberLabel: PropTypes.string,
  hasEmailCapture: PropTypes.bool,
  isEmailBotProtected: PropTypes.bool,
  isEmailCapturePrivacyConsentInputChecked: PropTypes.bool,
  isEmailCapturePrivacyConsentRequired: PropTypes.bool,
  languageOptions: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  languageValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  navigationItems: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    subItems: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
      text: PropTypes.string.isRequired
    })),
    target: PropTypes.string,
    text: PropTypes.string.isRequired
  })),
  onChangeCurrency: PropTypes.func.isRequired,
  onChangeEmailCaptureInput: PropTypes.func,
  onChangeLanguage: PropTypes.func.isRequired,
  onClickEmailCapturePrivacyConsentInput: PropTypes.func,
  phoneNumber: PropTypes.string,
  propertyAddress: PropTypes.string,
  socialMediaLinks: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    iconName: PropTypes.string,
    iconPath: PropTypes.string,
    target: PropTypes.string
  }))
} : {};